import styled from 'styled-components';

export const IconButton = styled.button`
background-color: transparent;
font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
font-size: 1.5rem;
border: none;
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 0.5rem;
color: white;
cursor: pointer;
`
